import React from 'react'

import Base from '../_Base'

const Previous = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="m6.793 11.293 8.5-8.5 1.414 1.414L8.914 12l7.793 7.793-1.414 1.414-8.5-8.5L6.086 12l.707-.707z"
    />
  </Base>
)

export default Previous
